import {
	LinearProgress,
	linearProgressClasses,
	Typography,
} from '@mui/material'
import ButtonCustom from '../../../../atoms/button/ButtonCustom'
import styles from '../index.module.scss'
import Modal from '../Modal/Modal'
import { useState } from 'react'

const Progress = ({ step }) => {
	const [activeModal, setActiveModal] = useState(false)
	const closeAllModals = () => {
		setActiveModal(false)
	}
	const handleSubmit = () => {
		setActiveModal(false)
	}
	return (
		<div className={styles.progressMain}>
            {/* commented out for launch */}
			{/* <Typography variant="h6" className={styles.completeProfileTitle}>
				On Time Magic Timeline Tool - Finish Survey
			</Typography>
			<LinearProgress
				variant="determinate"
				value={(step - 1) * 25}
				sx={{
					padding: '0.5rem',
					borderRadius: '1rem',
					backgroundColor: '#DFE4EB',
					[`& .${linearProgressClasses.bar}`]: {
						backgroundColor: '#7CA6BD',
						borderRadius: '50px',
					},
				}}
			/>
			<div className={styles.getStartRow}>
				<Typography variant="h6">
					Progress: {Math.max(step - 1, 0) * 25}%
				</Typography>
				<ButtonCustom
					variant="default"
					onClick={() => {
						setActiveModal(true)
					}}
				>
					{step === 0 ? 'Start Survey' : 'Continue'}
					<img src="/images/arrow_back.svg" alt="arrow" />
				</ButtonCustom>
			</div>
			<Modal activeModal={activeModal} closeAllModals={closeAllModals} /> */}
		</div>
	)
}

export default Progress
